import CompanyUpdate from './CompanyUpdate.vue'
export {CompanyUpdate}
export default CompanyUpdate

